// firebaseConfig.ts
// Firebase app initialisation — imported by pushNotifications.ts only.
// All values come from REACT_APP_FCM_* env vars so secrets stay out of source.

import { initializeApp, getApps, type FirebaseApp } from 'firebase/app';

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FCM_API_KEY            ?? '',
  authDomain:        process.env.REACT_APP_FCM_AUTH_DOMAIN        ?? '',
  projectId:         process.env.REACT_APP_FCM_PROJECT_ID         ?? '',
  storageBucket:     process.env.REACT_APP_FCM_STORAGE_BUCKET     ?? '',
  messagingSenderId: process.env.REACT_APP_FCM_MESSAGING_SENDER_ID ?? '',
  appId:             process.env.REACT_APP_FCM_APP_ID             ?? '',
};

// Avoid re-initialising if already done (React StrictMode double-invoke safe)
let firebaseApp: FirebaseApp;
if (getApps().length === 0) {
  firebaseApp = initializeApp(firebaseConfig);
} else {
  firebaseApp = getApps()[0];
}

export default firebaseApp;
